import { useMutation } from '@tanstack/react-query';

import { MutationProps } from '~/types/mutation';
import { queryClient } from '~/utils';

import { model } from '../';

import { merchantsQueryKey } from './useMerchants';

export const useDeleteMerchant = ({ onSuccess }: MutationProps) =>
  useMutation(model.delete, {
    onSuccess: () => {
      queryClient.invalidateQueries([merchantsQueryKey]);
      onSuccess?.();
    },
  });
